export const NAV_LINKS = [
  { to: '/dashboard', label: 'Dashboard', icon: '⊞' },
  { to: '/speakers',  label: 'Speakers',  icon: '🎤' },
  { to: '/events',    label: 'Events',    icon: '📅' },
  { to: '/export',    label: 'Export',    icon: '⬇' },
];
